var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { NestedDialogContextProvider } from "@react-md/dialog";
import { FormThemeProvider } from "@react-md/form";
import { IconProvider } from "@react-md/icon";
import { DEFAULT_RIPPLE_CLASSNAMES, DEFAULT_RIPPLE_TIMEOUT, StatesConfig, } from "@react-md/states";
import { DEFAULT_TOOLTIP_DELAY, TooltipHoverModeConfig, } from "@react-md/tooltip";
import { AppSizeListener, DEFAULT_APP_SIZE, DEFAULT_DESKTOP_LARGE_MIN_WIDTH, DEFAULT_DESKTOP_MIN_WIDTH, DEFAULT_DIR, DEFAULT_PHONE_MAX_WIDTH, DEFAULT_TABLET_MAX_WIDTH, DEFAULT_TABLET_MIN_WIDTH, Dir, UserInteractionModeListener, } from "@react-md/utils";
/**
 * This component allows you to quickly configure different functionality within
 * `react-md` in one place with reasonable defaults.
 */
export function Configuration(_a) {
    var onAppResize = _a.onAppResize, children = _a.children, icons = _a.icons, formTheme = _a.formTheme, _b = _a.defaultDir, defaultDir = _b === void 0 ? DEFAULT_DIR : _b, _c = _a.phoneMaxWidth, phoneMaxWidth = _c === void 0 ? DEFAULT_PHONE_MAX_WIDTH : _c, _d = _a.tabletMinWidth, tabletMinWidth = _d === void 0 ? DEFAULT_TABLET_MIN_WIDTH : _d, _e = _a.tabletMaxWidth, tabletMaxWidth = _e === void 0 ? DEFAULT_TABLET_MAX_WIDTH : _e, _f = _a.desktopMinWidth, desktopMinWidth = _f === void 0 ? DEFAULT_DESKTOP_MIN_WIDTH : _f, _g = _a.desktopLargeMinWidth, desktopLargeMinWidth = _g === void 0 ? DEFAULT_DESKTOP_LARGE_MIN_WIDTH : _g, _h = _a.defaultSize, defaultSize = _h === void 0 ? DEFAULT_APP_SIZE : _h, _j = _a.rippleTimeout, rippleTimeout = _j === void 0 ? DEFAULT_RIPPLE_TIMEOUT : _j, _k = _a.rippleClassNames, rippleClassNames = _k === void 0 ? DEFAULT_RIPPLE_CLASSNAMES : _k, _l = _a.disableRipple, disableRipple = _l === void 0 ? false : _l, _m = _a.disableProgrammaticRipple, disableProgrammaticRipple = _m === void 0 ? false : _m, _o = _a.disableTooltipHoverMode, disableTooltipHoverMode = _o === void 0 ? false : _o, _p = _a.tooltipDefaultDelay, tooltipDefaultDelay = _p === void 0 ? DEFAULT_TOOLTIP_DELAY : _p, _q = _a.tooltipDelayTimeout, tooltipDelayTimeout = _q === void 0 ? DEFAULT_TOOLTIP_DELAY : _q;
    return (React.createElement(Dir, { defaultDir: defaultDir },
        React.createElement(AppSizeListener, { defaultSize: defaultSize, onChange: onAppResize, phoneMaxWidth: phoneMaxWidth, tabletMinWidth: tabletMinWidth, tabletMaxWidth: tabletMaxWidth, desktopMinWidth: desktopMinWidth, desktopLargeMinWidth: desktopLargeMinWidth },
            React.createElement(NestedDialogContextProvider, null,
                React.createElement(UserInteractionModeListener, null,
                    React.createElement(StatesConfig, { disableRipple: disableRipple, disableProgrammaticRipple: disableProgrammaticRipple, rippleTimeout: rippleTimeout, rippleClassNames: rippleClassNames },
                        React.createElement(TooltipHoverModeConfig, { enabled: !disableTooltipHoverMode, defaultDelay: tooltipDefaultDelay, delayTimeout: tooltipDelayTimeout },
                            React.createElement(IconProvider, __assign({}, icons),
                                React.createElement(FormThemeProvider, __assign({}, formTheme), children)))))))));
}
/* istanbul ignore next */
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        var querySize = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
        Configuration.propTypes = {
            children: PropTypes.node.isRequired,
            onAppResize: PropTypes.func,
            phoneMaxWidth: querySize,
            tabletMinWidth: querySize,
            tabletMaxWidth: querySize,
            desktopMinWidth: querySize,
            desktopLargeMinWidth: querySize,
            defaultSize: PropTypes.shape({
                isPhone: PropTypes.bool.isRequired,
                isTablet: PropTypes.bool.isRequired,
                isDesktop: PropTypes.bool.isRequired,
                isLargeDesktop: PropTypes.bool.isRequired,
                isLandscape: PropTypes.bool.isRequired,
            }),
            rippleTimeout: PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.shape({
                    enter: PropTypes.number,
                    exit: PropTypes.number,
                }),
            ]),
            rippleClassNames: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.shape({
                    enter: PropTypes.string,
                    enterActive: PropTypes.string,
                    enterDone: PropTypes.string,
                    exit: PropTypes.string,
                    exitActive: PropTypes.string,
                }),
            ]),
            disableRipple: PropTypes.bool,
            disableProgrammaticRipple: PropTypes.bool,
            tooltipDelayTimeout: PropTypes.number,
            tooltipDefaultDelay: PropTypes.number,
            disableTooltipHoverMode: PropTypes.bool,
            icons: PropTypes.shape({
                back: PropTypes.node,
                checkbox: PropTypes.node,
                expander: PropTypes.node,
                dropdown: PropTypes.node,
                download: PropTypes.node,
                forward: PropTypes.node,
                menu: PropTypes.node,
                radio: PropTypes.node,
                password: PropTypes.node,
                notification: PropTypes.node,
                sort: PropTypes.node,
            }),
            formTheme: PropTypes.shape({
                theme: PropTypes.oneOf(["none", "underline", "outline", "filled"]),
                underlineDirection: PropTypes.oneOf(["left", "center", "right"]),
            }),
            defaultDir: PropTypes.oneOfType([
                PropTypes.func,
                PropTypes.oneOf(["ltr", "rtl"]),
            ]),
        };
    }
    catch (e) { }
}
//# sourceMappingURL=Configuration.js.map